"use client";

const _excluded = ["size"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
const InfoSystemIcon = props => {
  const {
      size = 24
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "INFO-SYSTEM-ICON"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconFill,
    fillRule: "nonzero",
    d: "M11.891 24.007c6.571 0 11.898-5.327 11.898-11.898S18.462.211 11.89.211-.007 5.538-.007 12.11 5.32 24.007 11.891 24.007m0-1.5c-5.743 0-10.398-4.655-10.398-10.398 0-5.743 4.655-10.398 10.398-10.398 5.743 0 10.398 4.655 10.398 10.398 0 5.743-4.655 10.398-10.398 10.398m0-14.866a1.122 1.122 0 1 0 0-2.243 1.122 1.122 0 0 0 0 2.243M11.89 18.79a.75.75 0 0 0 .751-.748l.014-7.677a.75.75 0 0 0-1.5-.003l-.014 7.677c0 .414.334.75.749.751"
  })));
};
InfoSystemIcon.displayName = "InfoSystemIcon";
InfoSystemIcon.iconName = "Info";
export default InfoSystemIcon;